import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-no-analytics-data',
  templateUrl: './no-analytics-data.component.html',
  styleUrls: ['./no-analytics-data.component.css']
})
export class NoAnalyticsDataComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
